import React from 'react';
import { Box, Skeleton } from '@mui/material';

export interface ChainViewSkeletonProps {
  stageCount?: number;
}

/** Shimmering placeholder shaped like `ChainView`'s stage-card row, so
 * switching entities doesn't flash a generic gray block — the loading state
 * already previews where the real cards will land. */
export default function ChainViewSkeleton({ stageCount = 5 }: ChainViewSkeletonProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: `repeat(${stageCount}, minmax(160px, 1fr))`, md: `repeat(${stageCount}, minmax(0, 1fr))` },
        gap: 1,
        overflowX: { xs: 'auto', md: 'visible' },
      }}
    >
      {Array.from({ length: stageCount }).map((_, i) => (
        <Skeleton key={i} variant="rounded" animation="wave" height={78} />
      ))}
    </Box>
  );
}
